import AspectRatio from '@blocks/AspectRatio'
import Image from '@blocks/Input/Image'
import { useConfigContext } from '@contexts/config'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import SalonGallerySidepanel from '@customer/components/sidepanels/SalonGallery'
import { formatBytes, notifyError } from '@helpers'
import validate from '@customer/models/Photo/helpers/validate'
import useSidepanel from '@hooks/useSidepanel'
import React from 'react'
import { useSalonSectionContext } from '../../../../context'

export default function SalonEmptyParticipation({ position }: Props) {
    const config = useConfigContext()
    const { salon, gallery } = useSalonContext()
    const { section, photos } = useSalonSectionContext()
    
    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (!file) return true

        const validated = validate.image(file, config)
        if (!validated) return true

        const photo = await gallery.actions.store(file)
        await salon.actions.participation.store(photo, section) 
        return true
    }
    
    const onChoose = async (photo: Interfaces.Photo) => {
        await salon.actions.participation.store(photo, section)
    }
    
    const sidepanel = useSidepanel()
    const openGallery = () => sidepanel.open(SalonGallerySidepanel, { photos, onChoose })

    return (
        <AspectRatio height={9} width={16}>
            <Image 
                id={position} 
                name={position}
                gallery={{
                    visible: Boolean(photos?.length),
                    onClick: openGallery
                }}
                onChange={handleChange} />
        </AspectRatio>
    )
}

interface Props {
    position: string
}